var _path, _circle, _circle2, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 24,
    viewBox: "0 0 130 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0078 17.9844H40.0293V19H31.7969V4.78125H33.0078V17.9844ZM43.9586 19H42.7574V4.78125H43.9586V19ZM49.5676 4.78125L54.8117 17.3301L60.0754 4.78125H61.677V19H60.4758V12.8086L60.5734 6.46094L55.2805 19H54.3527L49.0793 6.50977L49.177 12.7695V19H47.9758V4.78125H49.5676ZM73.282 15.0156H66.827L65.3621 19H64.1023L69.4832 4.78125H70.6258L76.0066 19H74.7566L73.282 15.0156ZM67.198 13.9902H72.9012L70.0496 6.24609L67.198 13.9902ZM88.8422 19H87.641L79.4672 6.83203V19H78.2562V4.78125H79.4672L87.6508 16.959V4.78125H88.8422V19ZM101.961 5.80664H97.0879V19H95.8867V5.80664H91.0234V4.78125H101.961V5.80664ZM105.88 19H104.679V4.78125H105.88V19ZM119.966 14.5664C119.803 16.0638 119.266 17.2096 118.355 18.0039C117.45 18.7982 116.242 19.1953 114.732 19.1953C113.677 19.1953 112.743 18.9316 111.929 18.4043C111.122 17.877 110.497 17.1315 110.054 16.168C109.611 15.1979 109.387 14.0911 109.38 12.8477V11.002C109.38 9.73893 109.601 8.61914 110.044 7.64258C110.487 6.66602 111.122 5.91406 111.948 5.38672C112.782 4.85286 113.739 4.58594 114.82 4.58594C116.343 4.58594 117.544 4.99935 118.423 5.82617C119.308 6.64648 119.823 7.78255 119.966 9.23438H118.755C118.456 6.81901 117.144 5.61133 114.82 5.61133C113.53 5.61133 112.502 6.0931 111.734 7.05664C110.972 8.02018 110.591 9.35156 110.591 11.0508V12.7891C110.591 14.4297 110.962 15.7383 111.704 16.7148C112.453 17.6914 113.462 18.1797 114.732 18.1797C115.988 18.1797 116.935 17.8802 117.573 17.2812C118.211 16.6758 118.605 15.7708 118.755 14.5664H119.966Z",
    fill: "#04222d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 3,
    fill: "#04222d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 3,
    fill: "#04222d"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3,
    fill: "#04222d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5L5 19H20",
    stroke: "#04222d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logoDark.d3777269189623d4d049280c1e4aedc2.svg";
export { ForwardRef as ReactComponent };